import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store';
import { ENUM_BONUS_LABEL, ENUM_CUS_EVENT } from '../../../enums/enums';
import { API_USER } from '../../../api/user';
import useToast from '../../useToast';
import { dispatchCusEvent } from '../../../utils';
import { setUpdateBonus } from '../../../store/apps/userSlice';
import { useDispatch } from 'react-redux';

const defaultCashback = {
  enabled: false,
  timeZone: 0,
  notAccrue: true,
  useCasinoTax: false,
  packets: []
};

export default function useEditBonusCashback(groupId) {
  const type = ENUM_BONUS_LABEL.cashback;
  const { successToast } = useToast();
  const dispatch = useDispatch();
  const group = useAppSelector((state) => state.user.group.hash?.[groupId]);
  const bonusCashback = useAppSelector((state) => state.user.bonus?.[groupId]?.[type]);
  const [cashbackStruct, setCashbackStruct] = useState(
    Array.isArray(bonusCashback) ? {} : bonusCashback || {}
  );
  const [updateSubgroups, setUpdateSubgroups] = useState(false);
  const [selectCurrency, setSelectCurrency] = useState(group?.currency);

  const cashbackEnable = cashbackStruct?.enabled;
  const cashbackTimeZone = String(cashbackStruct?.timeZone);
  const notAccrue = cashbackStruct?.notAccrue;
  const packets = cashbackStruct?.packets;
  const useCasinoTax = cashbackStruct?.useCasinoTax;
  const saveDisabled = !packets?.length;
  const lifetimeDays = cashbackStruct?.lifetimeDays;
  const lockSetting = cashbackStruct?.updateLocked;

  const changeSubgroup = () => setUpdateSubgroups((prev) => !prev);
  const changeEnable = () => setCashbackStruct((prev) => ({ ...prev, enabled: !cashbackEnable }));
  // const changeNotAccrue = () => setCashbackStruct((prev) => ({ ...prev, notAccrue: !notAccrue }));
  const changeNotAccrue = () => setCashbackStruct((prev) => ({ ...prev, notAccrue: true }));
  const changeCasinoTax = () => setCashbackStruct((p) => ({ ...p, useCasinoTax: !useCasinoTax }));
  const changeLifetimeDays = (val) => setCashbackStruct((p) => ({ ...p, lifetimeDays: val }));
  const changeLockSetting = () => setCashbackStruct((p) => ({ ...p, updateLocked: !lockSetting }));

  const changeAutoActive = (id, val) => {
    setCashbackStruct((prev) => {
      const newCashback = JSON.parse(JSON.stringify(prev));
      if (!newCashback.packets) newCashback.packets = [];
      if (!newCashback.packets[id]) newCashback.packets[id] = {};
      if (!newCashback.packets[id].options[selectCurrency])
        newCashback.packets[id].options[selectCurrency] = {};

      newCashback.packets[id].options[selectCurrency].userActivate = val;
      return newCashback;
    });
  };

  const changeToDeposit = (id, val) => {
    setCashbackStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      if (!newWelcome.packets) newWelcome.packets = [];
      if (!newWelcome.packets[id]) newWelcome.packets[id] = {};

      newWelcome.packets[id].toDeposit = val;
      return newWelcome;
    });
  };

  const changePayoutDays = (id, val) => {
    setCashbackStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      if (!newWelcome.packets) newWelcome.packets = [];
      if (!newWelcome.packets[id]) newWelcome.packets[id] = {};

      newWelcome.packets[id].payoutWeekDay = +val;
      return newWelcome;
    });
  };

  const changeHoldDay = (id, val) => {
    setCashbackStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      if (!newWelcome.packets) newWelcome.packets = [];
      if (!newWelcome.packets[id]) newWelcome.packets[id] = {};

      newWelcome.packets[id].holdDays = val;
      return newWelcome;
    });
  };

  const changeFieldPackage = (packageId, currency, currencyIndx, name, value) => {
    setCashbackStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      if (!newWelcome.packets) newWelcome.packets = [];
      if (!newWelcome.packets[packageId]) {
        newWelcome.packets[packageId] = {
          holdDays: 0,
          payoutWeekDay: 0,
          toDeposit: false,
          options: {
            [currency]: { userActivate: false }
          },
          values: {}
        };
      }
      const values = newWelcome.packets[packageId].values;
      if (!values) {
        newWelcome.packets[packageId].values = {};
      }
      if (Array.isArray(values) && !value.length) {
        newWelcome.packets[packageId].values = {};
      }
      if (!values[currency]) {
        newWelcome.packets[packageId].values[currency] = [];
      }
      const currentField = newWelcome.packets[packageId].values[currency][currencyIndx];
      if (!currentField) newWelcome.packets[packageId].values[currency][currencyIndx] = {};

      newWelcome.packets[packageId].values[currency][currencyIndx][name] = value;

      return newWelcome;
    });
  };

  const onDeleteRow = (packageId, currency, currencyIndx) => {
    setCashbackStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      const values = newWelcome.packets[packageId].values[currency];

      delete values[currencyIndx];
      newWelcome.packets[packageId].values[currency] = values.filter((el) => el);

      return newWelcome;
    });
  };

  const onSave = () => {
    const updateStore = () => {
      // если успех произошёл без ИД - то это создание
      if (!cashbackStruct.id) {
        dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });
        setUpdateSubgroups(false);
        return;
      }
      const bonusData = { id: groupId, bonusName: type, data: cashbackStruct };
      dispatch(setUpdateBonus(bonusData));
    };

    const bonusData = { ...defaultCashback, ...cashbackStruct };
    bonusData.notAccrue = true;

    const updateData = {
      groupId: +groupId,
      updateSubgroups,
      bonusLabel: type,
      bonusData: bonusData
    };

    API_USER.group.bonus
      .update(updateData)
      .then((e) => {
        updateStore();
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  const onCopyToDays = (activeDay, days) => {
    const currentPackage = packets?.[activeDay];

    setCashbackStruct((prev) => {
      const newCashback = JSON.parse(JSON.stringify(prev));
      days.forEach((dayId) => {
        newCashback.packets[dayId - 1] = currentPackage;
      });

      return newCashback;
    });

    successToast('The selected days are populated according to the template.');
  };

  useEffect(() => {
    if (!bonusCashback || Array.isArray(bonusCashback)) return;
    setCashbackStruct(bonusCashback);
  }, [bonusCashback]);

  return {
    cashbackEnable,
    cashbackTimeZone,
    notAccrue,
    packets,
    saveDisabled,
    lifetimeDays,
    useCasinoTax,
    lockSetting,
    updateSubgroups,
    selectCurrency,
    setSelectCurrency,
    changeSubgroup,
    changeLockSetting,
    changeCasinoTax,
    changeLifetimeDays,
    changeEnable,
    changeAutoActive,
    changePayoutDays,
    changeHoldDay,
    changeToDeposit,
    changeNotAccrue,
    changeFieldPackage,
    onDeleteRow,
    onCopyToDays,
    onSave
  };
}
